//client/src/pages/admin/AdminAnalytics.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminAnalytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/analytics").then((res) => setData(res.data));
  }, []);

  if (!data) return <div>Loading analytics…</div>;

  const { summary, dailyProfit, users, totalOrders } = data;

  const revenue = summary?.totalRevenue ?? 0;
  const profit = summary?.totalProfit ?? 0;

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">📊 Admin Profit Analytics</h1>

      <div className="grid md:grid-cols-4 gap-4">
        <Stat label="Users" value={users} />
        <Stat label="Orders" value={totalOrders} />
        <Stat label="Revenue" value={`₹${revenue.toFixed(2)}`} />
        <Stat
          label="Profit"
          value={`₹${profit.toFixed(2)}`}
          highlight
        />
      </div>

      <div className="card-glass p-6">
        <h2 className="font-semibold mb-4">Daily Profit</h2>

        <table className="w-full text-sm">
          <thead>
            <tr>
              <th>Date</th>
              <th>Orders</th>
              <th>Revenue</th>
              <th>Profit</th>
            </tr>
          </thead>
          <tbody>
            {dailyProfit.map((d) => (
              <tr key={d._id}>
                <td>{d._id}</td>
                <td>{d.orders}</td>
                <td>₹{(d.revenue || 0).toFixed(2)}</td>
                <td className="text-green-400">
                  ₹{(d.profit || 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <div
      className={`p-4 rounded-xl bg-black/30 ${
        highlight ? "border border-purple-500/40" : ""
      }`}
    >
      <div className="text-sm text-slate-400">{label}</div>
      <div className="text-xl font-bold">{value}</div>
    </div>
  );
}
